import { TableLayout } from '@templates/TableLayout/TableLayout';

import type { FiltersState } from './localState';
import { useLocalState } from './localState';
import { PayoutDraftsHeader } from './PayoutDraftsHeader';
import { PayoutDraftsTable } from './PayoutDraftsTable';

export const PayoutDrafts = () => {
  const {
    state: localState,
    dispatch,
    setFilters: updateFilters,
    updateCursorAfter,
    resetState
  } = useLocalState();

  const setFilters = (value: FiltersState) => {
    dispatch(updateFilters(value));
  };

  return (
    <TableLayout
      header={
        <PayoutDraftsHeader
          filters={localState.filters}
          setFilters={setFilters}
          resetState={resetState}
        />
      }
      content={
        <PayoutDraftsTable
          localState={localState}
          updateCursorAfter={updateCursorAfter}
        />
      }
    />
  );
};
